/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react'
import { Label } from './common/label'
import { useForm } from './form'
import { SelectFilterObj } from './common/select-filter-ob'
import { useLoad } from '../hooks/load'

export const FormSimpleCategorySelectFilter = ({ name, label, rootName, useApiListCategory, hidden, required }) => {
  const { register, setValue } = useForm(name, { required, valueAsNumber: true, forceChange: true, shouldDirty: true })

  const [selectedItem, updateSelectedItem] = useState(null)

  const apiListCategory = useApiListCategory()

  useLoad(() => {
    apiListCategory.get('hierarchy')
    updateSelectedItem(null)
  }, [])

  useLoad(() => (selectedItem && selectedItem.id ? setValue(selectedItem.id) : setValue(null)), [selectedItem])

  const items = useMemo(
    () => {
      let items = apiListCategory.items.map(item => {
        return { id: item.id, path: `/ ${rootName} ${item.path}` }
      })

      return [{ id: -1, path: `/ ${rootName}` }, ...items]
    },
    [apiListCategory]
  )

  return (
    <Label name={name} label={label} hidden={hidden} required={required}>
      <input type="hidden" {...register()} />
      <SelectFilterObj rootName={rootName} items={items} itemKey="path" selectedItem={selectedItem} onChange={updateSelectedItem} />
    </Label>
  )
}
